// eslint-disable-next-line no-use-before-define
import React from 'react';
/** Rótulo e valor de cada parte, separados por vírgula. */
export const TenantDescription = ({ parts, }) => (React.createElement(React.Fragment, null, parts.map((part, index) => (React.createElement("span", { key: part.value, className: "tenant-description_part" },
    index > 0 && ', ',
    !!part.label && `${part.label}: `,
    React.createElement("strong", null, part.value))))));
//# sourceMappingURL=tenant-description.js.map